import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { SelectOption } from 'common/types/select-option';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cacheSelectors } from 'redux/cache.slice';
import { RootState } from 'redux/root-reducer';
import { searchParamActions, searchParamSelectors } from 'redux/search-param.slice';
import { WsNativeSelect } from 'stories/inputs/WsNativeSelect';

const YearRange = () => {
  const dispatch = useDispatch();
  const listingsYearMin = useSelector((state: RootState) => cacheSelectors.listingsYearMin(state));
  const listingsYearMax = useSelector((state: RootState) => cacheSelectors.listingsYearMax(state));
  const yearMin = useSelector((state: RootState) => searchParamSelectors.yearMinF(state));
  const yearMax = useSelector((state: RootState) => searchParamSelectors.yearMaxF(state));
  const [rangeOptions, setRangeOptions] = useState<SelectOption[]>([]);

  const [runOnce, runOnceTo] = React.useState(true);

  React.useEffect(() => {
    if (runOnce) {
      runOnceTo(false);
      const options: SelectOption[] = [{ id: '*', label: 'Any' }];
      for (let i = listingsYearMax; i >= listingsYearMin; i--) options.push({ id: i.toString(), label: i.toString() });
      setRangeOptions(options);
    }
  }, [runOnce, listingsYearMin, listingsYearMax]);

  return (
    <Grid container gap={2} paddingTop={1}>
      <Box>
        <Typography color="primary" variant="subtitle1">
          Minumum:
        </Typography>
        <WsNativeSelect
          width={100}
          id="dateRangeMin"
          data={rangeOptions}
          value={yearMin}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            dispatch(searchParamActions.yearMin(event.target.value))
          }
        />
      </Box>
      <Box>
        <Typography color="primary" variant="subtitle1">
          Maximum:
        </Typography>
        <WsNativeSelect
          width={100}
          id="dateRangeMax"
          data={rangeOptions}
          value={yearMax}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            dispatch(searchParamActions.yearMax(event.target.value))
          }
        />
      </Box>
    </Grid>
  );
};

export default YearRange;
